"use client";

import { useCallback } from "react";
import { useRouter } from "next/navigation";

import { SignUpForm } from "@/components/form/sign-up";
import { type SearchParams } from "@/types";
import { getNewPath, getParam } from "@/utils/misc";

export const SignUp = ({ searchParams }: { searchParams?: SearchParams }) => {
  const router = useRouter();

  const onSignUpSuccess = useCallback(
    (token: string) => {
      const next = searchParams && getParam(searchParams, "next");
      router.push(
        getNewPath({
          destination: "/auth/verify",
          searchParams: {
            next,
            token,
          },
        }),
      );
    },
    [router, searchParams],
  );
  return <SignUpForm onSignUpSuccess={onSignUpSuccess} />;
};
